{
  "name": "oidc-client-ts",
  "version": "3.5.0",
  "description": "OpenID Connect (OIDC) & OAuth2 client library",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/authts/oidc-client-ts.git"
  },
  "homepage": "https://github.com/authts/oidc-client-ts#readme",
  "license": "Apache-2.0",
  "main": "dist/umd/oidc-client-ts.js",
  "types": "dist/types/oidc-client-ts.d.ts",
  "exports": {
    ".": {
      "types": "./dist/types/oidc-client-ts.d.ts",
      "import": "./dist/esm/oidc-client-ts.js",
      "require": "./dist/umd/oidc-client-ts.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist"
  ],
  "keywords": [
    "authentication",
    "oauth2",
    "oidc",
    "openid",
    "OpenID Connect"
  ],
  "scripts": {
    "build": "node scripts/build.js && npm run build-types",
    "build-types": "tsc -p tsconfig.build.json && api-extractor run",
    "clean": "git clean -fdX dist lib *.tsbuildinfo",
    "prepack": "npm run build",
    "test": "tsc && vitest run",
    "typedoc": "typedoc",
    "lint": "eslint --max-warnings=0 --cache .",
    "prepare": "husky"
  },
  "dependencies": {
    "jwt-decode": "^4.0.0"
  },
  "devDependencies": {
    "@eslint/eslintrc": "^3.2.0",
    "@eslint/js": "^9.18.0",
    "@microsoft/api-extractor": "^7.49.1",
    "@stylistic/eslint-plugin": "^2.13.0",
    "@testing-library/jest-dom": "^6.6.3",
    "@types/node": "^24.10.1",
    "@typescript-eslint/eslint-plugin": "^8.20.0",
    "@typescript-eslint/parser": "^8.20.0",
    "@vitest/coverage-v8": "^4.0.16",
    "esbuild": "^0.27.0",
    "eslint": "^9.18.0",
    "eslint-plugin-testing-library": "^7.1.1",
    "fake-indexeddb": "^6.0.0",
    "globals": "^17.0.0",
    "http-proxy-middleware": "^3.0.3",
    "husky": "^9.1.7",
    "jose": "^5.9.6",
    "jsdom": "^27.3.0",
    "lint-staged": "^16.1.0",
    "typedoc": "^0.28.0",
    "typescript": "~5.8.2",
    "vitest": "^4.0.16",
    "yn": "^5.0.0"
  },
  "engines": {
    "node": ">=18"
  },
  "lint-staged": {
    "*.{js,jsx,ts,tsx}": "eslint --cache --fix"
  }
}
